import { Controller } from "@hotwired/stimulus"

// Keeps a country <select> in sync with a tel <input>. When an international
// number (leading "+<dial code>") is loaded into the field — pre-filled from a
// prospect, or pasted by the user — it selects the matching country and strips
// the dial code, leaving the local number. Dial codes come from each
// <option>'s data-calling-code.
//
//   <div data-controller="phone-country">
//     <select data-phone-country-target="code">
//       <option value="GB" data-calling-code="44">🇬🇧 +44</option> …
//     </select>
//     <input type="tel" data-phone-country-target="number"
//            data-action="paste->phone-country#onPaste">
//   </div>
export default class extends Controller {
  static targets = ["code", "number"]

  connect() {
    this.applyInternational()
  }

  onPaste() {
    // Let the pasted text land in the field before reading it.
    requestAnimationFrame(() => this.applyInternational())
  }

  applyInternational() {
    const raw = this.numberTarget.value.trim()
    if (!raw.startsWith("+")) return

    const digits = raw.replace(/\D/g, "")
    const match = this.matchCountry(digits)
    if (!match) return

    this.codeTarget.value = match.alpha2
    this.numberTarget.value = digits.slice(match.code.length)
  }

  // Longest dial-code prefix wins. On a tie (e.g. +1 is US and CA), keep the
  // country already selected if it qualifies, otherwise take the first match.
  matchCountry(digits) {
    const matches = Array.from(this.codeTarget.options)
      .map((option) => ({ alpha2: option.value, code: option.dataset.callingCode || "" }))
      .filter((option) => option.code && digits.startsWith(option.code))
      .sort((a, b) => b.code.length - a.code.length)

    if (matches.length === 0) return null

    const longest = matches[0].code.length
    const tied = matches.filter((option) => option.code.length === longest)
    const selected = this.codeTarget.value
    return tied.find((option) => option.alpha2 === selected) || tied[0]
  }
}
